var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#EE7623",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.76 17.61h2.47q.81 0 1.33.18.53.18.83.48t.42.7q.12.39.12.82 0 .46-.12.88t-.43.74q-.3.31-.82.5-.52.18-1.31.18h-1.3v2.66H5.76zm2.46 3.47q.46 0 .75-.09.3-.09.47-.25a.87.87 0 0 0 .23-.4q.07-.23.07-.52 0-.3-.07-.52a.8.8 0 0 0-.25-.38q-.17-.15-.47-.23a2.9 2.9 0 0 0-.74-.08H6.95v2.47zm3.868-3.47h1.21v2.89h3.21v-2.89h1.21v7.14h-1.21v-3.13h-3.21v3.13h-1.21zm7.149 0h2.47q.81 0 1.33.18.53.18.83.48t.42.7q.12.39.12.82 0 .46-.12.88t-.43.74q-.3.31-.82.5-.52.18-1.31.18h-1.3v2.66h-1.19zm2.46 3.47q.459 0 .75-.09.3-.09.47-.25a.87.87 0 0 0 .23-.4q.07-.23.07-.52 0-.3-.07-.52a.8.8 0 0 0-.25-.38q-.17-.15-.47-.23a2.9 2.9 0 0 0-.74-.08h-1.26v2.47z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhp);
export default ForwardRef;